import { render } from "./VoiceMailRecord.vue?vue&type=template&id=df259858&scoped=true"
import script from "./VoiceMailRecord.vue?vue&type=script&lang=js"
export * from "./VoiceMailRecord.vue?vue&type=script&lang=js"

import "./VoiceMailRecord.vue?vue&type=style&index=0&id=df259858&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df259858"]])

export default __exports__